import { render, staticRenderFns } from "./BrazilBackButton.vue?vue&type=template&id=0e06a89f&scoped=true&"
import script from "./BrazilBackButton.vue?vue&type=script&lang=js&"
export * from "./BrazilBackButton.vue?vue&type=script&lang=js&"
import style0 from "./BrazilBackButton.vue?vue&type=style&index=0&id=0e06a89f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e06a89f",
  null
  
)

export default component.exports